import { useState } from 'react';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import { GOLD, fmt, Stat, Field, Card, EntryTable, useEntries } from './shared';

export const MaterialsTab = ({ api, jobId, readOnly }) => {
  const [data, reload] = useEntries(api, `/accounting/jobs/${jobId}/materials`, jobId);
  const [form, setForm] = useState({ vendor: '', item_description: '', quantity: 1, unit_cost: 0, date: '' });
  const add = async () => {
    if (!form.vendor || !form.item_description) return toast.error('Vendor and item required');
    try {
      await api.post(`/accounting/jobs/${jobId}/materials`, { job_id: jobId, ...form });
      setForm({ vendor: '', item_description: '', quantity: 1, unit_cost: 0, date: '' });
      reload(); toast.success('Material added');
    } catch { toast.error('Failed'); }
  };
  if (!jobId) return <p className="text-gray-500">Select a project.</p>;
  return (
    <div data-testid="fos-materials-tab">
      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        <Stat label="Total Material Cost" value={fmt(data.summary?.total_cost)} accent={GOLD} testid="materials-total-cost" />
        <Stat label="Entries" value={data.entries?.length || 0} />
      </div>
      {!readOnly && (
        <Card className="mb-6">
          <div className="grid sm:grid-cols-6 gap-3 items-end">
            <Field label="Vendor" type="text" value={form.vendor} onChange={(v) => setForm({ ...form, vendor: v })} testid="mat-vendor" />
            <Field label="Item" type="text" value={form.item_description} onChange={(v) => setForm({ ...form, item_description: v })} testid="mat-item" />
            <Field label="Qty" value={form.quantity} onChange={(v) => setForm({ ...form, quantity: v })} testid="mat-qty" />
            <Field label="Unit Cost" value={form.unit_cost} onChange={(v) => setForm({ ...form, unit_cost: v })} testid="mat-unit-cost" />
            <Field label="Date" type="date" value={form.date} onChange={(v) => setForm({ ...form, date: v })} testid="mat-date" />
            <button data-testid="mat-add-btn" onClick={add} className="h-10 inline-flex items-center justify-center gap-2 px-4 bg-[#C6A87C] text-white text-sm font-medium rounded-lg hover:opacity-90">
              <Plus className="w-4 h-4" /> Add
            </button>
          </div>
        </Card>
      )}
      <EntryTable
        headers={['Date', 'Vendor', 'Item', 'Qty', 'Unit', 'Total']}
        rows={(data.entries || []).map(e => [e.date, e.vendor, e.item_description, e.quantity, fmt(e.unit_cost), fmt(e.total_cost)])}
        testid="materials-table"
      />
    </div>
  );
};
